import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PayMethodPage from './PayMethodPage';
import './PayMethodPage.less';

export const prefix = 'bm-p-pay-method';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PayMethodPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
